import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckSquare,
  faChevronDown,
  faMinus,
  faPlus
} from "@fortawesome/free-solid-svg-icons";
import { faSquare } from "@fortawesome/free-regular-svg-icons";
import qs from "qs";
import Query from "./Query";

const Filter = props => {
  const { attributeCode, attributeName, attributeValues, partner } = props;
  const attributesBeforeLimiting = 4;
  const search = qs.parse(window.location.search.substr(1));
  const hasSelection = attributeValues.some(
    () => "filter" in search && attributeCode in search.filter
  );
  const hasDisabledPartnerFilter = partner && attributeCode === "brand";
  const hasNoOptions = attributeValues.length === 0;
  const hideFilter = hasDisabledPartnerFilter || hasNoOptions;
  const useLimiting =
    attributeValues.length > attributesBeforeLimiting && !hasSelection;
  const [isFilterCollapsed, setFilterCollapsed] = useState(false);
  const [isFilterLimited, setFilterLimited] = useState(useLimiting);
  const sorted = attributeValues.sort((a, b) => {
    if (a.facetCount === b.facetCount) {
      return a.label < b.label ? -1 : 1;
    }
    return a.facetCount > b.facetCount ? -1 : 1;
  });

  useEffect(() => {
    setFilterLimited(true);
  }, []);

  if (hideFilter) {
    return null;
  }

  return (
    <div
      className={`products__filter${isFilterCollapsed ? " is-collapsed" : ""}${
        isFilterLimited ? " is-limited" : ""
      }`}
    >
      <div className="products__filter-header">
        <h4 className="products__filter-name">{attributeName}</h4>
        <button
          type="button"
          className="products__filter-toggle"
          aria-label="Toggle Open"
          onClick={() => setFilterCollapsed(!isFilterCollapsed)}
        >
          <FontAwesomeIcon icon={faChevronDown} />
        </button>
      </div>
      <div className="products__filter-body">
        <ul className="products__filter-items">
          {sorted.map((attribute, index) => {
            const isPartner =
              attributeCode === "brand" && partner === attribute.attributeValue;
            const isFilter =
              "filter" in search &&
              attributeCode in search.filter &&
              search.filter[attributeCode] === attribute.attributeValue;
            const isChecked = isPartner || isFilter;
            const query = isChecked ? null : attribute.attributeValue;

            if (hasSelection && !isChecked) {
              return null;
            }

            return (
              <li
                key={attribute.attributeValue}
                className={
                  index > attributesBeforeLimiting - 1 ? "is-more" : ""
                }
                data-id={query}
              >
                <Query
                  search={{
                    filter: {
                      ...search.filter,
                      ...{ [attributeCode]: query }
                    },
                    page: null
                  }}
                  disabled={isPartner}
                >
                  {isChecked ? (
                    <FontAwesomeIcon
                      icon={faCheckSquare}
                      className="products__filter-icon"
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faSquare}
                      className="products__filter-icon"
                    />
                  )}
                  <span className="products__filter-label">
                    {attribute.label}
                  </span>
                  <span className="products__filter-count">
                    {attribute.facetCount}
                  </span>
                </Query>
              </li>
            );
          })}
        </ul>
        {useLimiting && (
          <button
            type="button"
            className="products__filter-more"
            aria-label="See More See Less"
            onClick={() => setFilterLimited(!isFilterLimited)}
          >
            {isFilterLimited ? (
              <span>
                <FontAwesomeIcon icon={faPlus} size="sm" />
                <span>See More </span>
              </span>
            ) : (
              <span>
                <FontAwesomeIcon icon={faMinus} size="sm" />
                <span>See Fewer </span>
              </span>
            )}
          </button>
        )}
      </div>
    </div>
  );
};

Filter.propTypes = {
  attributeCode: PropTypes.string.isRequired,
  attributeName: PropTypes.string.isRequired,
  attributeValues: PropTypes.arrayOf(
    PropTypes.shape({
      attributeValue: PropTypes.string.isRequired,
      label: PropTypes.string,
      facetCount: PropTypes.number.isRequired
    })
  ).isRequired,
  partner: PropTypes.string
};

Filter.defaultProps = {
  partner: null
};

export default Filter;
